import { formatPhoneNumber } from 'react-phone-number-input';

export default function FormatPhoneNumber(props) {

    const phoneNumber = (props.phoneNumber.length > 10) ? '+' + props.phoneNumber : 
                        (props.phoneNumber.length === 10) ? '+1' + props.phoneNumber :
                        "";
    
    return (phoneNumber ? formatPhoneNumber(phoneNumber) : props.phoneNumber);
}